export default "__VITE_ASSET__DFAFjfg1__"